/** Build the value stored in MarksSubmission.examLabel */
export function buildStoredExamLabel(assessmentType, assessmentTitle) {
    const type = String(assessmentType || "Class test").trim() || "Class test";
    const title = String(assessmentTitle || "").trim();
    return title ? `${type} — ${title}` : type;
}

/** Split stored examLabel into dropdown type + optional title */
export function parseStoredExamLabel(stored) {
    const raw = String(stored || "").trim() || "Class test";
    const sep = " — ";
    const idx = raw.indexOf(sep);
    const parsed = idx === -1
        ? { assessmentType: raw, assessmentTitle: "" }
        : {
              assessmentType: raw.slice(0, idx),
              assessmentTitle: raw.slice(idx + sep.length),
          };
    if (parsed.assessmentType === "Mid-term") {
        parsed.assessmentType = "Continuous assessment";
    }
    return parsed;
}

export const ASSESSMENT_TYPE_OPTIONS = [
    "Class test",
    "Assessment",
    "Continuous assessment",
    "End of term",
    "Mock exam",
    "CA Test",
];

export const LOCKED_MARKS_STATUSES = new Set([
    "Submitted",
    "FormApproved",
    "Approved",
]);
